import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { WishlistTooltipComponentService } from './components/wishlist-tooltip';

export function wishlistTooltipFactory(wishlistTooltipComponentService: WishlistTooltipComponentService): () => void {
  return () => wishlistTooltipComponentService.init();
}

@NgModule({
  imports: [],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = wishlistTooltipFactory(inject(WishlistTooltipComponentService));

      return initializerFn();
    }),
  ],
})
export class WishListUiModule {}
